const rightMenuWidthReducer = (state = 350, action) => {
    switch (action.type) {
      case "SET_RIGHT_MENU_WIDTH":
        return action.payload;
      default:
        return state;
    }
  }
  export default rightMenuWidthReducer;